
import Flex from "../data/Flex";
import UIFlex, { copyFlex, IUIFlexProps } from "../ui/UIFlex";
import './View.scss';

export interface IView extends IUIFlexProps{
    id:string;
    whiteBG?:boolean;
    animated?:boolean;
    padding?:boolean;

}

export default function View($props:IView){
    

    let cn:string = "view "+$props.id;
    if($props.className) cn+=" "+$props.className;
    if($props.whiteBG) cn+=" whiteBG";
    if($props.animated) cn+=" animated";
    if($props.padding) cn+=" padding";

    let flex = copyFlex({direction:Flex.COLUMN},$props.flex);

    return (
        <UIFlex className={cn} flex={flex} onClick={$props.onClick}>
            {$props.children}
        </UIFlex>
    );
}